import React from 'react';

export default function PrivacyPolicy() {
  return (
    <div style={styles.container}>
      <div style={styles.policyContent}>
        <p style={styles.text}>
           Option bricks values and respects every individual’s right to privacy. By becoming our customer, we promise to remain loyal to both clients and non-clients and protect the information provided to us.
        </p>
        <p style={styles.text}>
          <strong>This Privacy Policy of  Option bricks is applicable to both current and former clients. Below are detailed testimonials of our policy:</strong>
        </p>
        <p style={styles.text}>
          The information provided by you will only be used for offering you the services that you have subscribed to and for which you have provided us the information. It acts as your identity with us. If you make any changes to the information, please inform us via call or email.
        </p>
        <p style={styles.text}>
          We may use your information for sending emails, newsletters, contest information, surveys, or details about new services. By subscribing to our services, you agree to this right.
        </p>
        <p style={styles.text}>
          The personal information collected is kept confidential and adheres to our privacy policy. We may disclose your identity if required by law to government or regulatory bodies.
        </p>
        <p style={styles.text}>
          For more details, visit our website: <a href="http://optionbricks.in/" style={styles.link}> Option bricks</a>.
        </p>
        <p style={styles.text}>
          By registering your mobile number with  Option bricks, you consent to be contacted or receive SMS, even if your number is on the DND registry. You also agree to comply with our Privacy Policy and Terms & Conditions.
        </p>
        <p style={styles.text}>
          In case of changes to your contact information, please notify us via call or email. Your information will not be sold, rented, or transferred without your consent, except for providing services or meeting legal obligations.
        </p>
        <p style={styles.text}>
          By subscribing to our services, you consent to our Privacy Policy and Terms of Use.
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: {
    
    fontFamily: 'Arial, sans-serif',
   // backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    // boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '100vw',
    margin: '0px auto',
  },
  policyContent: {
    lineHeight: '1.8',
    color: '#333',
  },
  text: {
    marginBottom: '16px',
    fontSize: '16px',
  },
  link: {
    color: '#007BFF',
    textDecoration: 'none',
    fontWeight: 'bold',
  },
};
